export const LOGO_DOCUMENT_PROPS = {
  label: 'Company Logo',
  maxFiles: 1,
  maxSize: 20 * 1024 * 1024,
  accept: ['image/*'],
  compressImages: true,
};
